export default "__VITE_ASSET__d953f28c__"